import { Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { logout } from '../../redux/authSlice';

const Logout = () => {
  const dispatch = useDispatch();

  const doLogout = () => {
    dispatch(logout());
  };

  return (
    <Button className='ms-2' onClick={doLogout}>
      Abmelden
    </Button>
  );
};

export default Logout;
